import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { LanguageKey } from '../../../../main/translate/language-key/language-key';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  selector: 'app-button-edit-rounded',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    TooltipModule,
    PipesModule,
    RouterModule,
  ],
  templateUrl: './button-edit-rounded.component.html',
  styleUrls: ['./button-edit-rounded.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonEditRoundedComponent {
  public languageKey = LanguageKey;
}
